import * as types from '@/store/mutations'
import api from '@/services/profile'


const getters = {
  profile: (state) =>  {
    if (state.profile) {
      return state.profile
    }

    return false
  },
  servedBy: (state) =>  {
    if (state.servedBy) {
      return state.servedBy
    }

    return ''
  },
  profileDraft: (state) =>  {
    if (state.profileDraft) {
      return state.profileDraft
    }
    return false
  }

}

const actions = {
  loadProfile(store){
    return new Promise((resolve, reject) => {
      api.getProfile().then(res => {
        store.commit(types.SET_PROFILE, res.data)
        resolve(res)
      }).catch((ex)=>{
        reject(ex)
      })
    })

  },
  loadProfileDraft(store){
    return new Promise((resolve, reject) => {
      api.getProfileDraft().then(res => {
        store.commit(types.SET_PROFILE_DRAFT, res)
        resolve(res)
      }).catch((ex)=>{
        reject(ex)
      })
    })

  },
  loadAllActiveProfiles(store){
    return new Promise((resolve, reject) => {
      api.getAllActiveProfiles().then(res => {
        store.commit(types.SET_PROFILES, res)
        resolve(res)
      }).catch((ex)=>{
        reject(ex)
      })
    })

  },

  loadAllDraftProfiles(store){
    return new Promise((resolve, reject) => {
      api.getAllDraftProfiles().then(res => {
        store.commit(types.SET_PROFILE_DRAFTS, res)
        resolve(res)
      }).catch((ex)=>{
        reject(ex)
      })
    })
  },

  saveProfile(context, payload  ) {
    return new Promise((resolve, reject) => {
      api.storeProfile(payload).then((res) =>{
        resolve(res)
      }).catch((ex)=>{
        reject(ex)
      })
    })
  },

  adminSaveProfile(context, payload  ) {
    return new Promise((resolve, reject) => {
      api.adminStoreProfile(payload).then((res) =>{
        resolve(res)
      }).catch((ex)=>{
        reject(ex)
      })
    })
  },
  
  getPreApproveDraftProfile(context, id ) {
    return new Promise((resolve, reject) => {
      api.getPreApproveDraftProfile(id).then((res) =>{
        resolve(res)
      }).catch((ex)=>{
        reject(ex)
      })
    })
  },

  approveDraftProfile(context, id ) {
    return new Promise((resolve, reject) => {
      api.approveDraftProfile(id).then((res) =>{
        resolve(res)
      }).catch((ex)=>{
        reject(ex)
      })
    })
  },

  uploadProfileImage(context, payload ) {
        return new Promise((resolve, reject) => {
            api.uploadProfileImage(payload).then( res => {
              resolve(res)
          }).catch((e) => {
              reject(e)
          })
      })
  },
  loadProfileSettings() {
    return new Promise((resolve, reject) => {
      api.getProfileSettings().then((res)=>{
        resolve(res)
      }).catch((ex)=>{
        reject(ex)
      })
    })
  },
  storeProfileSettings(context, payload  ) {
    return new Promise((resolve, reject) => {
      api.setProfileSettings(payload).then((res)=>{
        resolve(res)
      }).catch((ex)=>{
        reject(ex)
      })
    })
  }

}

const mutations = {
  [types.SET_PROFILE] (state, { profile }) {
    state.profile = profile
  },
  [types.SET_SERVED_BY] (state,  servedBy ) {
    state.servedBy = servedBy
  },
  [types.SET_PROFILE_DRAFT] (state, { profiledraft }) {
    state.profileDraft = profiledraft
  },
  [types.SET_PROFILES] (state, { profiles }) {
    state.profiles = profiles
  },
  [types.SET_PROFILE_DRAFTS] (state, { profiledrafts }) {
    state.profileDrafts = profiledrafts
  }


}

const state = {
  profile: null,
  profiles: null, /*all profiles - for admin*/
  profileDraft: null,
  servedBy:'',
  profileDrafts: null /*all pending profiles - for admin*/
}

export default {
  getters,
  actions,
  mutations,
  state
}
